
// src/components/Forms/AddWebsiteForm.js
import React, { useState } from 'react';
import { Form, Button, Alert } from 'react-bootstrap';
import useWebsiteStore from '../../store/websiteStore';

const AddWebsiteForm = ({ onSuccess }) => {
    const [formData, setFormData] = useState({
        url: '',
        name: '',
    });
    const [errors, setErrors] = useState({});

    const { addWebsite, loading, error } = useWebsiteStore();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.url) {
            newErrors.url = 'URL je povinné';
        } else if (!/^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w.-]*)*\/?$/.test(formData.url)) {
            newErrors.url = 'Neplatná URL';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;

        try {
            const data = await addWebsite(formData);
            setFormData({ url: '', name: '' });
            if (onSuccess) onSuccess(data);
        } catch (error) {
            // Chyby jsou již zpracovány v store
        }
    };

    return (
        <div className="card fade-in">
            <div className="card-body">
                <h5 className="mb-4">Přidat nový web</h5>

                {error && <Alert variant="danger">{error}</Alert>}

                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label>URL webu *</Form.Label>
                        <Form.Control
                            type="text"
                            name="url"
                            value={formData.url}
                            onChange={handleChange}
                            placeholder="https://example.com"
                            isInvalid={!!errors.url}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.url}
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-4">
                        <Form.Label>Název webu (volitelné)</Form.Label>
                        <Form.Control
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            placeholder="Můj web"
                        />
                    </Form.Group>

                    <div className="d-grid">
                        <Button
                            type="submit"
                            variant="primary"
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                    Přidávám...
                                </>
                            ) : (
                                <>
                                    <i className="fas fa-plus me-2"></i> Přidat web
                                </>
                            )}
                        </Button>
                    </div>
                </Form>
            </div>
        </div>
    );
};

export default AddWebsiteForm;